import { useEffect } from 'react';

import { checkVersion } from './utils';

export const useMessages = () => {
  useEffect(() => {
    // Check version on mount
    checkVersion();
  }, []);

  return {};
};
